export default __webpack_public_path__ + "static/media/ezyfind-logo-dark.810025fa.png";